import { useEffect } from 'react';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';

import { useState } from 'react';
import {
  Modules,
  sellerLearningCenterApiClient,
} from '@/api/seller/serv/oec_seller_learning_center_api';
import { CODE_SUCCESS } from '@features/constants/network';
import { getPopRegion, usePopQuery } from '@/hooks/usePopQuery';

export const usePublicModule = () => {
  const { i18n } = useTranslation();
  const [moduleList, setModuleList] = useState<Modules[]>([]);
  const { region } = usePopQuery();

  const fetchPublicModule = async () => {
    const res = await sellerLearningCenterApiClient.GetModules({
      pop_region: getPopRegion(),
    });
    if (res.code === CODE_SUCCESS && res.data) {
      // learning_id equal to 0 means dirty data, need to be filtered
      setModuleList(
        (
          res.data?.modules?.map(module => ({
            ...module,
            learning_info: module?.learning_info
              ?.filter(item => Number(item.learning_id) !== 0)
              .slice(0, 3),
          })) || []
        ).filter(module => module.learning_info?.length),
      );
    }
  };

  useEffect(() => {
    fetchPublicModule();
  }, [i18n.language, region]);

  return {
    moduleList,
  };
};
